import { Hook } from 'lib/vendor/terrific/Sandbox';
import { Module } from 'lib/vendor/terrific/Module';

export default class FusionSearch extends Module {

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {

		const $ctx = this.$ctx;

		// Fetch jQuery objects once to re-use in submit action
		const $container = $ctx.find('.scsh-fusionsearch-container');
		const $form = $container.find('FORM.scsh-fusionsearch-form');
		const $field = $container.find('INPUT.scsh-fusionsearch-field');

		// Store for re-use in submit action
		const action = $form.attr('action');

		// Handle form submit event
		$form.on('submit', event => {

			// Abort if no action is defined
			if (action === undefined) { return; }
			// Abort if the event is already canceled
			if (event.isDefaultPrevented()) { return; }

			// Parse the action url (preserve all information)
			const url = new URL(action, document.location.href);
			const pair = url.hash.replace(/^#+/, '').split('?', 2);

			// Decode parameters and update our property
			const params = new URLSearchParams(pair[1]);
			params.set('query', String($field.val()));

			// Update the final action url
			pair[1] = String(params);
			url.hash = '#' + pair.join('?');
			$form.attr('action', url.href);

		});
		// EO on submit

		callback();
	}

}
// EO class FusionSearch



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/search/Tc.Module.FusionSearch.ts